import React from 'react';

const HowItWorksSection = () => {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center md:mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-800/80">Product story</p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">From first estimate to final invoice.</h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate-600 md:text-lg">
            DevelloTech keeps the full job lifecycle organized in one contractor management workspace.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 md:gap-8">
          <div className="group text-center">
            <div className="shadow-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-primary to-accent text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              1
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Create a client</h3>
            <p className="leading-relaxed text-slate-600">
              Keep contact details and project context in the same dashboard before the first estimate goes out.
            </p>
          </div>
          <div className="group text-center">
            <div className="shadow-cyan-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-accent to-primary text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              2
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Build a quote with materials, labor, tax, overhead, and markup</h3>
            <p className="leading-relaxed text-slate-600">
              Use the professional quote builder with material price search by city or region on Pro to set confident pricing.
            </p>
          </div>
          <div className="group text-center">
            <div className="shadow-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-primary to-accent text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              3
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Generate and send a professional PDF</h3>
            <p className="leading-relaxed text-slate-600">
              Deliver polished quote and invoice documents with your logo and clear pricing. Email PDFs directly from Devello on Pro.
            </p>
          </div>
          <div className="group text-center">
            <div className="shadow-cyan-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-accent to-primary text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              4
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Convert the job into a project</h3>
            <p className="leading-relaxed text-slate-600">
              Move from accepted quote to organized execution on Pro — and invite team members into assigned projects when you need help in the field.
            </p>
          </div>
          <div className="group text-center">
            <div className="shadow-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-primary to-accent text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              5
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Track costs, receipts, files, and progress</h3>
            <p className="leading-relaxed text-slate-600">
              Keep expenses, uploads, notes, and job updates tied to the same project so nothing gets lost.
            </p>
          </div>
          <div className="group text-center">
            <div className="shadow-cyan-glow mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-accent to-primary text-2xl font-black text-white transition-transform duration-300 group-hover:scale-110">
              6
            </div>
            <h3 className="mb-3 text-xl font-bold text-slate-900">Send the final invoice</h3>
            <p className="leading-relaxed text-slate-600">
              Close the job with clean invoice PDFs and complete records from first quote to final invoice. Email delivery from Devello is included on Pro.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
